import type { TersaImageModel } from '../../types';
import { providers } from '../../../providers';
import { alibaba } from '../../alibaba';
import { wavespeed } from '../../wavespeed';

// 美元汇率
const RMB_TO_USD = 1 / 6.8;
// rmb to usd 转换
const usd = (rmb: number) => rmb * RMB_TO_USD;
const COST_FACTOR = 1.5;

export const zimageModels: Record<string, TersaImageModel> = {
    'z-image-turbo': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/z-image/turbo'),
                modelBackup_create: [alibaba.image('z-image-turbo')],
                model_edit: wavespeed.image('wavespeed-ai/z-image/turbo'),
                getCost: () => usd(0.1 * COST_FACTOR),
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'z-image-base': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: wavespeed.image('wavespeed-ai/z-image/base'),
                getCost: () => usd(0.2 * COST_FACTOR),
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};